



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import MotoristaCollection from '@/model/collection/MotoristaCollection'
import Motorista from '@/model/resource/Motorista'
import ItDriverPerformance from '@/components/itrack/ItDriverPerformance.vue'

@Component({
  components: { ItDriverPerformance },
})
export default class DriverPerformance extends Vue {
  @Prop({ type: Object, required: true }) performance!: MotoristaCollection

  get motoristaBaixaPortal(): Motorista {
    const motoristaBaixaPortal = this.performance.items.reduce((motoristaBaixa, motorista) => {
      if (motoristaBaixa.qtdEntregasViaWeb === null) {
        motoristaBaixa.qtdEntregasViaWeb = 0
      }

      if (motoristaBaixa.qtdEntregasFinalizadas === null) {
        motoristaBaixa.qtdEntregasFinalizadas = 0
      }

      if (motoristaBaixa.qtdEntregas === null) {
        motoristaBaixa.qtdEntregas = 0
      }

      motoristaBaixa.qtdEntregas += motorista.qtdEntregasViaWeb ? motorista.qtdEntregasViaWeb : 0
      motoristaBaixa.qtdEntregasFinalizadas += motorista.qtdEntregasFinalizadasViaWeb
        ? motorista.qtdEntregasFinalizadasViaWeb
        : 0

      return motoristaBaixa
    }, new Motorista())

    motoristaBaixaPortal.nome = this.$t('component.driverPerformance.approvedWebLabel') as string

    return motoristaBaixaPortal
  }
}
